module.exports = __webpack_public_path__ + "static/media/xml.a83ee4db.svg";